import {
  toPlainObject, result, capitalize, values, toString, isArray, isObject, isString
} from 'lodash';

const errorResolver = (errorData) => {
  const defaultMessage = result(errorData, 'message');
  const errors = result(errorData, 'response.data.errors') || result(errorData, 'response.data');

  const errorResult = {
    errors: toPlainObject(errorData),
    message: ''
  };

  if (isArray(errors)) {
    errorResult.message = capitalize(toString(errors)) || 'An error occured';

    return errorResult;
  }

  if (isObject(errors)) {
    errorResult.message = toString(values(errors));

    return errorResult;
  }

  if (isString(errors)) {
    errorResult.message = toString(errors);

    return errorResult;
  }

  errorResult.message = capitalize(toString(defaultMessage)) || 'An error occured';

  return errorResult;
};

export default errorResolver;
